import framesProcessingService from '../device/framesProcessingService';
import HIDClient from './hidClient';
import {initConnection, onConnectionChange} from '../device/connectionService';
import deviceConnectionStatusTypes from '../../consts/device/deviceConnectionStatusTypes';

const connect = async ({isNewDevice, onDeviceSelect, onDeviceInitialization, isReconnect}) => {
    const options = {
        onDeviceConnect: async () => {
            onDeviceSelect?.();
            framesProcessingService.createNew();
            // TODO: replace with callback
            // hidReconnectHandlerService.clearHidReconnectHandlerState();

            const data = await initConnection({isReconnect});

            onConnectionChange(deviceConnectionStatusTypes.CONNECTED);
            onDeviceInitialization(data);
        },
        onDisconnected: async (isForceDisconnected) => {
            // TODO: uncomment this when we have a way to set the state
            // pairingService.onDeviceDisconnect(isForceDisconnected);

            onConnectionChange(
                isForceDisconnected
                    ? deviceConnectionStatusTypes.DISCONNECTED
                    : deviceConnectionStatusTypes.DISCONNECTED_WITH_RECONNECT
            );
        },
    };
    const hidClient = new HIDClient(true, options);

    await hidClient.connectDevice({isNewDevice});
};

const isClientInitialized = () => {
    try {
        new HIDClient();

        return true;
    } catch (e) {
        return false;
    }
};

const disconnect = () => {
    const hidClient = new HIDClient();

    hidClient.disconnect();
};

const isDeviceConnected = () => {
    const hidClient = new HIDClient();

    return hidClient.isDeviceConnected();
};

const unmount = () => {};

export default {
    connect,
    disconnect,
    isClientInitialized,
    isDeviceConnected,
    unmount,
};
